module.exports = __webpack_public_path__ + "media/images/home/hand_with_mobile-25085221bcf64d3d1211e6f97a366de3.png";